import { Feature } from '@tencent/workbench';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWActionType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { config } from './config';
import BaseMobileContextMenuFeature from '@framework/workbench/common/feature/base-mobile-context-feature';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import { getDeleteTDWType } from '@src/slide/domain/ui-model/utils/report';


@Feature()
export class DeleteFeature extends BaseMobileContextMenuFeature {
    id = config.name;

    public delete() {
        const { lastMouseDownRegion } = this.getSelectionService();
        switch (lastMouseDownRegion) {
            case RegionType.EDITOR:
                this.deleteElement();
                break;
            case RegionType.SLIDELIST:
                this.deleteSlide();
                break;
            default:
                this.deleteElement();
        }
    }

    private deleteElement() {
        const model = this.getSelectionService().selectedElements.getCurrentModel();
        if (model) {
            const tdwModule = getDeleteTDWType(model.type);
            if (tdwModule) {
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: tdwModule,
                    action: TDWActionType.M_EDIT_DELETE,
                });
            }
            this.getSelectionService().currentSlide?.deleteElement();
        }
    }

    private deleteSlide() {
        this.getUiDataService().presentation.deleteSlide();
    }
}
